<div class="ui-input">
  <label *ngIf="label" [for]="'input-' + uniqueId" class="block text-sm font-medium text-gray-700 mb-1">{{ label }}</label>
  <input
    [id]="label ? 'input-' + uniqueId : null"
    [type]="inputType"
    [placeholder]="placeholder"
    [value]="value"
    [disabled]="disabled"
    [required]="required"
    [min]="min"
    [max]="max"
    [step]="step"
    [class]="inputClasses"
    (input)="onValueChange($any($event.target).value)"
  />
</div>
